// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hE8c","title":"styles_title__3kBP2"};